import {Component, Input, OnInit} from '@angular/core';
import {Studium} from '../model/studium';
import {AppService} from '../app.service';

@Component({
  selector: 'app-studium-detail',
  templateUrl: './studium-detail.component.html',
  styleUrls: ['./studium-detail.component.css']
})
export class StudiumDetailComponent implements OnInit {

  @Input()
  studium: Studium;

  constructor(private appService: AppService) { }

  ngOnInit() {
    this.studium = this.appService.getStudium();
  }

  openSkolnePoplatkyApp() {
    this.appService.openPortalAppWindow('ais.gui.lz.poplatky.LZ040_ZoznamPoplatkovOsobyDlg', this.studium.id);
  }

  openStipendiaApp() {
    this.appService.openPortalAppWindow('ais.gui.vs.es.VSES203_DoplnujuceInformacieDlg', this.studium.id);
  }

  openUdelovanieSuhlasovApp() {
    this.appService.openPortalAppWindow('ais.gui.lz.LZ063_UdelovanieSuhlasovDlg', this.studium.id);
  }

  openMobilityApp() {
    this.appService.openPortalAppWindow('ais.gui.vs.es.VSES262_MobilityDlg', this.studium.id);
  }

  openKomplexnaKontrolaApp() {
    this.appService.openPortalAppWindow('ais.gui.vs.es.kontroly.VSES330_KomplexnaKontrolaStudiaDlg', this.studium.id);
  }

  openPovinnePredmetyApp() {
    this.appService.openPortalAppWindow('ais.gui.vs.es.VSES133_StudijneKontrolaPovinnychPredmetovDlg', this.studium.id);
  }

  openNeuspesneZapisyApp() {
    this.appService.openPortalAppWindow('ais.gui.vs.es.VSES132_StudijneKontrolaPoctuZapisovPredmetovDlg', this.studium.id);
  }

  openAbsolvovaniePredmetovApp() {
    this.appService.openPortalAppWindow('ais.gui.vs.es.VSES157_StudijneKontrolaAbsolvovanychPredmetovDlg', this.studium.id);
  }

  openZiskaneKredityApp() {
    this.appService.openPortalAppWindow('ais.gui.vs.es.studijne.VSES127_StudijnePrehladKreditovStudentaDlg', this.studium.id);
  }

  openPredpisanaSkladbaApp() {
    this.appService.openPortalAppWindow('ais.gui.vs.es.kontroly.VSES331_SplneniePredpisanejSkladbyDlg', this.studium.id);
  }
}
